import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { HttpEventLoaderService } from '@shared/service';

export function TVAHttpInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const httpEventLoaderService = inject(HttpEventLoaderService);
  httpEventLoaderService.show();
  return next(req).pipe(finalize(() => httpEventLoaderService.hide()));
}
